import { RadioGroupItem } from '@components/ui/radio';
import { Label } from '@components/ui/form/label';
import { SchedulerSidebarConfirmOptionProps } from './types';

export const SchedulerSidebarConfirmOption = ({
  id,
  value,
  label,
  items,
  emptyLabel,
}: SchedulerSidebarConfirmOptionProps) => (
  <div className="flex items-start gap-2">
    <RadioGroupItem value={value} id={id} className="shrink-0" />
    <Label htmlFor={id} className="flex cursor-pointer flex-col">
      <span className="text-xs font-normal text-neutral-700">{label}</span>
      <span className="text-xs font-normal text-neutral-500">
        {items.length ? items.join(', ') : emptyLabel}
      </span>
    </Label>
  </div>
);
